/* ─── A1CW Theme V15 · mega-menu.js ─────────────────────
   Desktop: hover + focus open the matching mega panel.
   Mobile : hamburger opens drawer; top-link toggles accordion.
   Keyboard: Arrow keys navigate top items; Escape closes.
   ──────────────────────────────────────────────────────── */

(function () {
  'use strict';

  var nav = document.querySelector('[data-mega-nav]');
  var toggle = document.querySelector('[data-mega-toggle]');
  var backdrop = document.querySelector('[data-mega-backdrop]');
  if (!nav) return;

  var items = Array.prototype.slice.call(nav.querySelectorAll('.mega-nav__item--has-children'));
  var topLinks = Array.prototype.slice.call(nav.querySelectorAll('.mega-nav__top-link'));
  var isDesktop = function () { return window.matchMedia('(min-width: 901px)').matches; };

  // ── Open/close mega panels ───────────────────────────
  function openPanel(item) {
    items.forEach(function (other) { if (other !== item) closePanel(other); });
    item.classList.add('is-open');
    var trigger = item.querySelector('[data-mega-trigger]');
    var panel = item.querySelector('[data-mega-panel]');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    if (panel) panel.hidden = false;
    if (backdrop && isDesktop()) {
      backdrop.hidden = false;
      backdrop.setAttribute('data-open', 'true');
    }
  }

  function closePanel(item) {
    item.classList.remove('is-open');
    var trigger = item.querySelector('[data-mega-trigger]');
    var panel = item.querySelector('[data-mega-panel]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (panel) panel.hidden = true;
  }

  function closeAllPanels() {
    items.forEach(closePanel);
    if (backdrop) {
      backdrop.removeAttribute('data-open');
      backdrop.hidden = true;
    }
  }

  // ── Desktop: hover + focus ───────────────────────────
  items.forEach(function (item) {
    var trigger = item.querySelector('[data-mega-trigger]');
    var panel = item.querySelector('[data-mega-panel]');
    var hoverTimer;

    item.addEventListener('mouseenter', function () {
      if (!isDesktop()) return;
      clearTimeout(hoverTimer);
      openPanel(item);
    });

    item.addEventListener('mouseleave', function () {
      if (!isDesktop()) return;
      hoverTimer = setTimeout(function () { closePanel(item); refreshBackdrop(); }, 120);
    });

    // Click on top trigger:
    // - Desktop: toggle (so keyboard/touch can open without hover)
    // - Mobile : prevent navigation, toggle accordion
    if (trigger) {
      trigger.addEventListener('click', function (e) {
        if (!isDesktop()) {
          // mobile: stop navigation, toggle accordion
          e.preventDefault();
          if (item.classList.contains('is-open')) {
            closePanel(item);
          } else {
            openPanel(item);
          }
          return;
        }
        // desktop: clicking the link itself should follow the URL,
        // so only intercept when the click is on the chevron area.
        if (e.target.closest('.mega-nav__chevron')) {
          e.preventDefault();
          if (item.classList.contains('is-open')) {
            closePanel(item);
            refreshBackdrop();
          } else {
            openPanel(item);
          }
        }
      });

      trigger.addEventListener('focus', function () {
        if (!isDesktop()) return;
        openPanel(item);
      });
    }

    // Close when focus leaves the panel completely
    item.addEventListener('focusout', function (e) {
      if (!isDesktop()) return;
      setTimeout(function () {
        if (!item.contains(document.activeElement)) {
          closePanel(item);
          refreshBackdrop();
        }
      }, 0);
    });
  });

  function refreshBackdrop() {
    if (!backdrop) return;
    var anyOpen = items.some(function (i) { return i.classList.contains('is-open'); });
    if (!anyOpen) {
      backdrop.removeAttribute('data-open');
      backdrop.hidden = true;
    }
  }

  // Click backdrop or outside nav → close panels
  if (backdrop) {
    backdrop.addEventListener('click', closeAllPanels);
  }

  document.addEventListener('click', function (e) {
    if (!isDesktop()) return;
    if (!nav.contains(e.target)) closeAllPanels();
  });

  // ── Keyboard navigation ──────────────────────────────
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeAllPanels();
      if (nav.getAttribute('data-open') === 'true') closeDrawer();
    }
  });

  topLinks.forEach(function (link, idx) {
    link.addEventListener('keydown', function (e) {
      if (!isDesktop()) return;
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        e.preventDefault();
        var dir = e.key === 'ArrowRight' ? 1 : -1;
        var next = topLinks[(idx + dir + topLinks.length) % topLinks.length];
        next.focus();
      }
      if (e.key === 'ArrowDown') {
        var item = link.closest('.mega-nav__item--has-children');
        if (item) {
          e.preventDefault();
          openPanel(item);
          var firstSub = item.querySelector('.mega-panel a');
          if (firstSub) firstSub.focus();
        }
      }
    });
  });

  // ── Mobile drawer ────────────────────────────────────
  function openDrawer() {
    nav.setAttribute('data-open', 'true');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    document.body.classList.add('mega-drawer-open');
    if (backdrop) {
      backdrop.hidden = false;
      backdrop.setAttribute('data-open', 'true');
    }
  }
  function closeDrawer() {
    nav.removeAttribute('data-open');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('mega-drawer-open');
    closeAllPanels();
  }

  if (toggle) {
    toggle.addEventListener('click', function () {
      if (nav.getAttribute('data-open') === 'true') closeDrawer();
      else openDrawer();
    });
  }

  if (backdrop) {
    backdrop.addEventListener('click', function () {
      if (!isDesktop() && nav.getAttribute('data-open') === 'true') closeDrawer();
    });
  }

  // Close drawer if resizing to desktop
  var lastIsDesktop = isDesktop();
  window.addEventListener('resize', function () {
    var nowDesktop = isDesktop();
    if (nowDesktop !== lastIsDesktop) {
      if (nowDesktop) closeDrawer();
      else closeAllPanels();
    }
    lastIsDesktop = nowDesktop;
  });
})();
